import store from '../store';

const BrandPlugin = {
    install(app) {
        app.config.globalProperties.$brand = store.state.brand;
    },
};

export default BrandPlugin;
